import Button from '../../Button'
import { Container } from '../Container'

import { BUTTON_ICON_SIZES, BUTTON_SIZES } from './Buttons.constants'

import * as styles from './Buttons.module.css'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export function OutlinedGrey() {
  return (
    <>
      <Container label='Button, outlined, grey, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            isGrey
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, disabled, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            disabled
            isGrey
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            isGrey
            isLoading
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, with pre icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            isGrey
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, with pre icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            isGrey
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, with post icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            isGrey
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, with post icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <Button.Outlined
            isGrey
            isLoading
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            isGrey
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            disabled
            isGrey
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            isGrey
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, circle icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            isCircle
            isGrey
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, circle icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            disabled
            isCircle
            isGrey
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, outlined, grey, circle icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <Button.Outlined
            isCircle
            isGrey
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
